import { api } from '@halo/web-lib';
import type { FleetGridResponse, FleetActivityResponse, FleetSummaryResponse } from './types';

const BASE = '/api/v1/ingestion/admin';

export async function fetchFleetGrid(params: {
  days: number;
  storeId?: number;
  platform?: string;
  exceptionsOnly?: boolean;
}): Promise<FleetGridResponse> {
  const qs = new URLSearchParams({ days: String(params.days) });
  if (params.storeId) qs.set('storeId', String(params.storeId));
  if (params.platform) qs.set('platform', params.platform);
  if (params.exceptionsOnly) qs.set('status', 'exceptions');
  const res = await api.get<FleetGridResponse>(`${BASE}/fleet-grid?${qs.toString()}`);
  if (!res.success || !res.data) throw new Error(res.error ?? 'fleet-grid failed');
  return res.data;
}

export async function fetchFleetActivity(params: {
  days: number;
  limit: number;
  platform?: string;
  storeId?: number;
}): Promise<FleetActivityResponse> {
  const qs = new URLSearchParams({ days: String(params.days), limit: String(params.limit) });
  if (params.platform) qs.set('platform', params.platform);
  if (params.storeId) qs.set('storeId', String(params.storeId));
  const res = await api.get<FleetActivityResponse>(`${BASE}/fleet-activity?${qs.toString()}`);
  if (!res.success || !res.data) throw new Error(res.error ?? 'fleet-activity failed');
  return res.data;
}

export async function fetchFleetSummary(): Promise<FleetSummaryResponse> {
  const res = await api.get<FleetSummaryResponse>(`${BASE}/fleet-summary`);
  if (!res.success || !res.data) throw new Error(res.error ?? 'fleet-summary failed');
  return res.data;
}

// ── Actions (reuse existing endpoints) ──────────────────────────────────────

export async function retryDay(storeId: number, platform: string, date: string): Promise<void> {
  const res = await api.post(`${BASE}/backfill`, {
    storeId,
    platform,
    dates: [date],
    force: true,
    triggerSource: 'admin',
  });
  if (!res.success) throw new Error(res.error ?? 'retry failed');
}

export async function pullNow(storeId: number, platform: string): Promise<void> {
  const res = await api.post(`${BASE}/pull-now`, { storeId, platform, triggerSource: 'admin' });
  if (!res.success) throw new Error(res.error ?? 'pull-now failed');
}
